import React from "react";
import { useParams } from "react-router-dom";

import { ScheduledVariantHeader } from "./ScheduledVariantHeader";
import { useScheduledWorkflowVariant } from "./useScheduledWorkflowVariant";
import { TwoButtonModal } from "../../../components/Modals";
import { ScheduledVariantRuns } from "./ScheduledVariantRuns";
import NavBanner from "../../../components/Banners/NavBanner";
import { useDialog } from "../../../contexts/DialogContext";

export default function ViewScheduledWorkflowVariantRuns() {
  const { workflowId, scheduledWorkflowId } = useParams();
  const { openDialog, closeDialog } = useDialog();
  const {
    workflowData,
    variantData,
    scheduledRunsData,
    isVariantDataLoading,
    deleteScheduledVariant,
  } = useScheduledWorkflowVariant(workflowId, scheduledWorkflowId);

  const handleDelete = () => {
    openDialog(
      <TwoButtonModal
        titleText="Delete scheduled workflow variant"
        bodyText="Are you sure you want to delete this scheduled workflow's variant? This action cannot be undone."
        actionText="Delete"
        cancelText="Cancel"
        onAction={() => {
          deleteScheduledVariant(variantData.id);
          closeDialog();
        }}
        onCancel={closeDialog}
        variant="danger"
      />
    );
  };

  return (
    <>
      <NavBanner />

      <div className="py-6">
        {/* header */}
        <ScheduledVariantHeader
          variant={variantData}
          isLoading={isVariantDataLoading}
          onDelete={handleDelete}
        />

        {/* runs table */}
        {workflowData && scheduledRunsData && (
          <ScheduledVariantRuns
            workflow={workflowData}
            runs={scheduledRunsData}
          />
        )}
      </div>
    </>
  );
}
